import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { WithChildrenProps } from '@app/types/generalTypes';

const RequireAuth: React.FC<WithChildrenProps> = ({ children }) => {
  const { accessToken, isAuthenticated } = useAppSelector((state) => state.token);

  // Check both accessToken and isAuthenticated to ensure user is properly authenticated
  // This prevents access when tokens are restored from localStorage but are invalid/expired
  if (!accessToken || !isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
